import React, { ReactNode } from 'react';
import { Layout, Menu, Breadcrumb, Avatar, Dropdown } from 'antd';
import {
  AppstoreOutlined,
  DatabaseOutlined,
  DashboardOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined as ExitIcon,
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const { Header, Sider, Content } = Layout;

interface Props {
  children: ReactNode;
}

const AppLayout: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { key: 'dashboard', icon: <DashboardOutlined />, label: 'Dashboard' },
    { key: 'inventory', icon: <DatabaseOutlined />, label: 'Inventory' },
    { key: 'manufacturing', icon: <AppstoreOutlined />, label: 'Manufacturing' },
    {
      key: 'hr',
      icon: <UserOutlined />,
      label: 'HR'
    }
  ];

  const currentKey = location.pathname.replace('/', '');
  const currentPage = menuItems.find((item) => item.key === currentKey)?.label || 'ERP System';

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const breadcrumbItems = pathSegments.map((seg, index) => {
    const url = '/' + pathSegments.slice(0, index + 1).join('/');
    return {
      title: seg.charAt(0).toUpperCase() + seg.slice(1).replace(/-/g, ' '),
      key: url,
      onClick: () => navigate(url)
    };
  });

  const handleMenuClick = ({ key }: { key: string }) => {
    if (key === 'logout') {
      localStorage.clear();
      navigate('/');
    } else {
      navigate(`/${key}`);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider>
        <div style={{ color: 'white', padding: '1rem', fontWeight: 'bold' }}>ERP System</div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[currentKey]}
          onClick={handleMenuClick}
          items={menuItems}
        />
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="edit-profile" icon={<UserOutlined />}>
                Edit Profile
              </Menu.Item>
              <Menu.Item key="settings" icon={<SettingOutlined />}>
                Settings
              </Menu.Item>
              <Menu.Item key="logout" icon={<ExitIcon />} onClick={() => handleMenuClick({ key: 'logout' })}>
                Logout
              </Menu.Item>
            </Menu>
          }
          placement="topLeft"
        >
          <div style={{ position: 'absolute', bottom: 20, left: 20, color: 'white', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
            <Avatar shape="circle" style={{ backgroundColor: '#1890ff' }}>
              JD
            </Avatar>
            <span>John Doe</span>
          </div>
        </Dropdown>
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 1rem' }}>
        <Breadcrumb
          style={{ margin: '1rem 1rem 0', cursor: 'pointer' }}
          items={breadcrumbItems}
        />
        </Header>

        <Content style={{ margin: '1rem' }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
